import React, {Fragment} from 'react'
import { graphql, StaticQuery } from 'gatsby'


class Content extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            device: 'desktop'
        }
    }

    componentDidMount() {
        if (typeof window !== 'undefined') {
			if (window.innerWidth > 1000) {
				this.setState({ device: 'desktop'})
			} else {
				this.setState({ device: 'mobile'})
			}
		}
    }

    render(){
        const {albert_phone_hand, albert_phone, usp_book, usp_house, usp_play, senior_mobile_albert} = this.props.query;
        
            return(
                <Fragment>
                    <section className="man-section">
                        <div className="custom-container">
                            <div className="col-md-6 col-sm-6 col-lg-6 col-xs-12 for-mobile">
                                <figure>
                                    <img src={albert_phone_hand.publicURL} />
                                </figure>
                            </div>
                            <div className="col-md-6 col-sm-6 col-lg-6 col-xs-12">
                                <figcaption>
                                    <h3>All kunskap samlad på <br/>ett ställe </h3>
                                    <p>Taluppfattning, algebra, geometri och  matematiska <br/> formuleringar. Allt finns samlat och strukturerat i <br/> tusentals pedagogiska övningar och animerade lektioner.</p>
                                </figcaption>
                            </div>
                            <div className="col-md-6 col-sm-6 col-lg-6 col-xs-12 desktop">
                                <figure>
                                    <img src={albert_phone_hand.publicURL} />
                                </figure>
                            </div>
                        </div>
                    </section>
                    
                    <section className="man-section second">
                        <div className="custom-container">
                        <div className="col-md-6 col-sm-6 col-lg-6 col-xs-12">
                                <figure className="desktop">
                                    <img src={albert_phone.publicURL} />
                                </figure>
                                 <figure className="for-mobile">
                                    <img src={senior_mobile_albert.publicURL} />
                                </figure>
                            </div>
                            
                        <div className="col-md-6 col-sm-6 col-lg-6 col-xs-12">
                            <figcaption>
                                <h3 className="desktop">Alltid tillgänglig när du <br/> vill, ett klick bort </h3>
                                <h3 className="for-mobile">Alltid tillgänglig när du vill,  ett <br/>  klick bort</h3>
                                <p className="desktop">På bussen, rasten eller kvällen innan provet. Albert finns <br/> alltid nära till hands, när du vill. Det ska vara enkelt, <br/> roligt och bekvämt att plugga matte!</p>
                                <p className="for-mobile">På bussen, rasten eller kvällen innan provet. Albert <br/> finns alltid nära till hands, när du vill. Det ska vara <br/> enkelt, roligt och bekvämt att plugga matte!</p>
                            </figcaption>
                        </div>
                            
                        </div>
                    </section>
                    
                    <section className="albert-three">
                        <div className="custom-container">
                    
                            <ul>
                                <li>
                                    <figure><img src={usp_house.publicURL}/></figure>
                                    <figcaption>
                                        <h4>Utvecklad av erfarna<br/>pedagoger och lärare</h4>
                                        <p>Tusentals uppgifter och interaktiva övningar, <br/>speciellt framtagna för att öka förståelsen och glädjen för matematik.</p>
                                    </figcaption>
                                </li>
                                <li>
                                    <figure><img src={usp_play.publicURL}/></figure>
                                    <figcaption>
                                        <h4 className="desktop">Hundratals animerade lektioner</h4>
                                         <h4 className="for-mobile">Hundratals animerade <br/> lektioner</h4>
                                        <p className="desktop">Tillgång till +300 animerade lektioner som med <br/> exempel från det verkliga livet garanterat gör matten roligare.</p>
                                         <p className="for-mobile">Tillgång till +300 animerade lektioner som med <br/> exempel från det verkliga livet garanterat <br/> gör matten roligare.</p>
                                         
                                         
                                    </figcaption>
                                </li>
                                <li>
                                    <figure><img src={usp_book.publicURL}/></figure>
                                    <figcaption>
                                        <h4>Övningar baserade på <br/> gällande läroplan</h4>
                                        <p>Tillgång till tusentals övningar som anpassats <br/> efter årskurs och svenska läroplanens kunskapsmål.</p>
                                        
                                    </figcaption>
                                </li>
                            </ul>
                        </div>
                    </section>
                </Fragment>
            )
    }
}

export default (props) => (
    <StaticQuery
        query= { graphql`
                query {
                    albert_phone_hand: file(relativePath: {regex: "/albert_phone_hand/"}) {
                        publicURL
                    }
                    albert_phone: file(relativePath: {regex: "/mralbert_phone/"}) {
                        publicURL
                    }
                    usp_house: file(relativePath: {regex: "/usp-house/"}) {
                        publicURL
                    }
                    usp_play: file(relativePath: {regex: "/usp-play/"}) {
                        publicURL
                    }
                    usp_book: file(relativePath: {regex: "/usp-book/"}) {
                        publicURL
                    }
                    senior_mobile_albert: file(relativePath: {regex: "/senior-mobile-albert/"}) {
                        publicURL
                    }
                }
                
                `
            }
        render={(data)  => (
           <Content query={data} {...props}/>
        )}
    />
)